<template lang='pug'>
.dpb-week-days
  .dpbwd-table(v-for='(calendar, idx) in calendarList' :key='idx')
    .dpbwd-table-month {{ calendar.year }} 年 {{ calendar.month }}
    .dpbwd-table-items
      table.dpbwd-table-items-table
        thead
          tr
            th(v-for='(day) in dayList') {{ day }}
        tbody
          tr(v-for='(week) in calendar.weeks')
            td(:id='getId(calendar, date)' v-for='(date) in week' :class='getDisableClass(calendar, date)' @mouseenter='hover' @click='clickEvent(calendar, date)' @mouseleave='leave')
              .page-table-item
                strong.page-table-text {{ date }}
</template>

<script>
import CalendarFactory from '@/plugins/calendar_factory.js'
import { newDateObject, deviceType, isMobileOrTablet } from '@/plugins/tool.js'

export default {
  props: {
    startDate: String,
    date1: String,
    date2: String
  },
  data() {
    return {
      dayList: ['日', '一', '二', '三', '四', '五', '六'],
      calendarList: [],
      start: newDateObject(this.startDate),
      end: new Date(),
      select1: null,
      select2: null
    }
  },
  created() {
    this.generateCalendar()
  },
  mounted() {
    if (this.date1 && this.date2) {
      this.click(this.date1)
      this.click(this.date2)
    }
    const elem = document.getElementsByClassName('dpb-week-days')[0]
    if (this.select1) {
      const selectElement = document.getElementById(this.select1)
      const scrollHeight = selectElement.offsetTop - selectElement.offsetHeight
      elem.scrollTo(0, scrollHeight)
    }
    else
      elem.scrollTo(0,elem.scrollHeight);
  },
  methods: {
    isMobile() {
      const type = deviceType()
      if (type === 'mobile' || type === 'tablet')
        return true
      return false
    },
    generateCalendar() {
      this.calendarList = (new CalendarFactory(this.start, this.end)).new()
    },
    getDisableClass(calendar, date) {
      const year = calendar.year
      const month = calendar.month
      if (date === '')
        return 'disable'
      const d = newDateObject(year+'-'+month+'-'+date)
      var start = newDateObject(this.start)
      start.setDate(start.getDate() - 1)
      var end = newDateObject(this.end)
      if (d.valueOf() > end.valueOf() || d.valueOf() <= start.valueOf()) {
        return 'disable'
      }
      return ''
    },
    hover() {
      var elem = event.toElement
      if (this.isMobile() && isMobileOrTablet() !== 'none') {
        this.select(elem)
        return
      }
      if (this.select1 != null && this.select2 != null) return
      this.setDateClass(elem, 'active')
    },
    leave() {
      var elem = event.fromElement
      if (this.isSelected(elem)) return
      this.setDateClass(elem, '')
    },
    setDateClass(element, className) {
      if (this.isDisabled(element)) return
      element.className = className
    },
    clickEvent(data, date) {
      if ('ontouchstart' in window)
        return
      this.click(data, date)
    },
    touchEvent(data, date) {
      if (!('ontouchstart' in window))
        return
      this.click(data, date)
    },
    click(data, date) {
      var id
      if (!date)
        id = this.getId(data)
      else
        id = this.getId(data, date)
      const elem = document.getElementById(id)
      this.select(elem)
    },
    select(elem) {
      const id = elem.id
      if (this.isDisabled(elem)) return

      if (this.select1 === null || this.select2 !== null) {
        this.cleanClass('active')
        this.cleanClass('range')
        this.select2 = null
        this.select1 = id
        this.$emit('newselect')
      }
      else {
        this.select2 = id
        if (newDateObject(this.select1) > newDateObject(this.select2)) {
          var tmp = this.select1
          this.select1 = this.select2
          this.select2 = tmp
        }
        this.range()
        this.$emit('select', this.select1, this.select2)
      }

      this.setDateClass(elem, 'active')
    },
    range() {
      const rangeClass = 'range'
      this.cleanClass(rangeClass)
      if (this.select1 === null || this.select2 === null) return

      var date1 = newDateObject(this.select1)
      var date2 = newDateObject(this.select2)
      var d = newDateObject(date1)
      d.setDate(d.getDate() + 1)
      for (; d < date2; d.setDate(d.getDate() + 1)) {
        const id = d.yyyymmdd().split('/').join('-')
        var elem = document.getElementById(id)
        this.setDateClass(elem, rangeClass)
      }
    },
    cleanClass(className) {
      var elems = document.getElementsByClassName(className)
      for (var i=elems.length-1; i >= 0 ; --i) {
        elems[i].className = ''
      }
    },
    getId(calendar, date) {
      if (calendar && (date === null || date === undefined))
        return calendar.split('/').join('-')
      return calendar.year.toString() + '-' + calendar.month.toString() + '-' + date.toString()
    },
    isDisabled(elem) {
      return elem.className.includes('disable')
    },
    isSelected(elem) {
      if (elem.id === this.select1 || elem.id === this.select2) {
        return true
      }
      if (elem.className.includes('range'))
        return true
      return false
    }
  }
}
</script>
<style>
&.range.last-range:before {
  width: 200% !important;
  margin-left: -40%;
  z-index: 0;
}
</style>
